import { useContext } from "react";
import { AppContext } from "context/AppContext";
import AboutMe from "components/AboutMe/AboutMe";
import Notifications from "components/Notifications/Notifications";
import RecentActivities from "components/RecentActivities/RecentActivities";


const Profile = () => {
    const {
        userSession
    } = useContext(AppContext);

    const ssoUser  = userSession.data?.user?.ssoUser;
    
    return (
        <div>
            <AboutMe />
            <Notifications />
            {!ssoUser &&
                <RecentActivities />
            }
        </div>
    );
};

export default Profile;